import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "input"]

  connect() {
    this.updateStars()
  }

  select(event) {
    const value = event.currentTarget.dataset.value
    this.inputTarget.value = value
    this.updateStars()
  }

  updateStars() {
    const rating = parseInt(this.inputTarget.value) || 0
    
    this.starTargets.forEach((star, index) => {
      const starValue = parseInt(star.dataset.value)
      
      if (starValue <= rating) {
        star.classList.remove('text-gray-300')
        star.classList.add('text-yellow-500')
      } else {
        star.classList.remove('text-yellow-500')
        star.classList.add('text-gray-300')
      }
    })
  }
}
